export interface ICreateDriverClassification {
    name: string;
    description?: string | null;
    calculatingDeliveryCostPerKilometer?: boolean;
    deliveryCostPerKilometer: number;
    orderDeliveryCost: number;
    extraOrderFixedBonusEnabled?: boolean;
    extraOrderFixedBonusAmount?: number;
}

export interface IUpdateDriverClassification extends ICreateDriverClassification {
}

export interface IExportDriverClassificationExcel {
    id: boolean;
    name: boolean;
    description: boolean;
    calculatingDeliveryCostPerKilometer: boolean;
    deliveryCostPerKilometer: boolean;
    orderDeliveryCost: boolean;
    extraOrderFixedBonusEnabled: boolean;
    extraOrderFixedBonusAmount: boolean;
    createdAt: boolean;
}

export const columnsExportDriverClassificationExcel = [
    "id",
    "name",
    "description",
    "calculatingDeliveryCostPerKilometer",
    "deliveryCostPerKilometer",
    "orderDeliveryCost",
    "extraOrderFixedBonusEnabled",
    "extraOrderFixedBonusAmount",
    "createdAt",
];
